import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { apiFetch } from "./api";

export const Login = ({ onSuccess }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const data = await apiFetch("/auth/login", {
                method: "POST",
                body: { email, password },
            });
            onSuccess(data.token, data.user);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            data-testid="admin-login"
            className="flex min-h-screen items-center justify-center bg-[#0A0D14] px-4"
        >
            <div className="w-full max-w-sm rounded-3xl border border-white/10 bg-[#121722] p-8 shadow-2xl shadow-black/60">
                <img
                    src="/logo-stacked.webp"
                    alt="AdvantaShield Warranty"
                    width="900"
                    height="600"
                    loading="lazy"
                    decoding="async"
                    className="mx-auto h-24 w-auto"
                />
                <h1 className="mt-4 text-center font-display text-xl font-bold text-white">
                    Admin Portal
                </h1>
                <p className="mt-1 text-center text-sm text-slate-500">
                    Sign in to manage AdvantaShield
                </p>
                <form onSubmit={submit} className="mt-7 flex flex-col gap-4">
                    <input
                        data-testid="admin-login-email"
                        type="email"
                        required
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="h-11 w-full rounded-lg border border-white/15 bg-[#0C1019] px-3 text-sm text-white placeholder:text-slate-600 focus:outline-none focus:ring-1 focus:ring-sky-400"
                    />
                    <input
                        data-testid="admin-login-password"
                        type="password"
                        required
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="h-11 w-full rounded-lg border border-white/15 bg-[#0C1019] px-3 text-sm text-white placeholder:text-slate-600 focus:outline-none focus:ring-1 focus:ring-sky-400"
                    />
                    {error && (
                        <p
                            data-testid="admin-login-error"
                            className="rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-xs text-red-300"
                        >
                            {error}
                        </p>
                    )}
                    <button
                        data-testid="admin-login-submit"
                        type="submit"
                        disabled={loading}
                        className="mt-1 inline-flex h-11 items-center justify-center gap-2 rounded-full bg-sky-400 text-sm font-bold text-[#0A0D14] transition-colors duration-300 hover:bg-sky-300 disabled:opacity-60"
                    >
                        {loading ? (
                            <Loader2 className="h-4 w-4 animate-spin" />
                        ) : (
                            <Lock className="h-4 w-4" />
                        )}
                        {loading ? "Signing in…" : "Sign In"}
                    </button>
                </form>
            </div>
        </div>
    );
};
